export const loginUrl = process.env.NODE_ENV === 'production' ? window.location.hostname : 'wm-test310.newtamp.cn'
// {
//   // activeRule: '/amc/market-radar/',
//   name: 'sub-app-radar',
//   entry: process.env.NODE_ENV === 'production' ? window.location.origin + '/amc/market-radar/' : '//localhost:7000/amc/market-radar',
//   container: '#sub-viewport',
//   props: { routerBase: '/amc/sub-app-radar/' }
//   // routerBase: '/amc/market-radar'
// },
export const micorApps = [
  {
    activeRule: '/manage/manage/dashbi',
    name: 'sub-app-dashbi',
    entry: process.env.NODE_ENV === 'production' ? window.location.origin + '/amc/amc-dashbi/' : '//localhost:3000',
    container: '#sub-dashbi',
    props: { routerBase: '/amc/amc-dashbi/' }
    // routerBase: '/amc/market-radar'
  },
]
